import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AssistanceMethods } from '@/help.search';
let AssistanceMethod = class AssistanceMethod extends Vue {
    get asEnum() {
        return AssistanceMethods[this.data];
    }
    get title() {
        return `Assistance is requested using ${this.text}`;
    }
    get iconClass() {
        if (this.asEnum === AssistanceMethods.FuelService)
            return "fad fuelService";
        else if (this.asEnum === AssistanceMethods.AssistanceButton)
            return "fad fa-concierge-bell";
        else if (this.asEnum === AssistanceMethods.AppOrWebsite)
            return "fad fa-mobile-alt"; //></i>"fad fa-app-store" //TODO:BCS "fab" ??
        else
            throw new Error(`${this.data} is not a valid value of AssistanceMethods`);
    }
    get text() {
        if (this.asEnum === AssistanceMethods.FuelService)
            return "fuelService";
        else if (this.asEnum === AssistanceMethods.AssistanceButton)
            return "Assistance Button";
        else if (this.asEnum === AssistanceMethods.AppOrWebsite)
            return "App or Website";
        else
            throw new Error(`${this.data} is not a valid value of AssistanceMethods`);
    }
};
tslib_1.__decorate([
    Prop()
], AssistanceMethod.prototype, "data", void 0);
AssistanceMethod = tslib_1.__decorate([
    Component
], AssistanceMethod);
export default AssistanceMethod;
//  export enum AssistanceMethods {
//    FuelService = 1,
//    AssistanceButton = 2,
//    AppOrWebsite = 3,
//}
//    (1, 'fuelService'),
//(2, 'Assistance Button'),
//(3, 'App or Website')
